import React from 'react';

import { Container, Paper } from '@mui/material';
import { Loading } from '@uplift/pages';
import { ProviderLayout, ProviderLayoutPageHeader, useCanAccessPracticeStates } from '@uplift/ui-v2';
import { makeStyles } from 'tss-react/mui';
import { PracticeStatesTable } from './components/PracticeStatesTable';
import { PracticeStatesStatusFilter, PracticeStatesStatusFilterValue } from './components/PracticeStatesStatusFilter';
import { usePracticeStatesData } from './practice-states-page.hooks';

const useStyles = makeStyles()(theme => ({
  desktopContainer: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

export const PracticeStatesPage = () => {
  const { classes } = useStyles();
  const { canAccess, isLoading: accessLoading } = useCanAccessPracticeStates();
  const { rows, isLoading: dataLoading } = usePracticeStatesData();
  const [ statusFilter, setStatusFilter ] = React.useState<PracticeStatesStatusFilterValue>('all');

  const filteredRows = React.useMemo(() => {
    if (statusFilter === 'all') return rows;
    return rows.filter(r => r.status === statusFilter);
  }, [ rows, statusFilter ]);

  if (accessLoading) {
    return (
      <ProviderLayout>
        <Loading fixed />
      </ProviderLayout>
    );
  }

  if (!canAccess) {
    return null;
  }

  return (
    <ProviderLayout>
      <ProviderLayoutPageHeader
        title="Practice States"
        actions={(
          <PracticeStatesStatusFilter
            rows={rows}
            value={statusFilter}
            setValue={setStatusFilter}
          />
        )}
      />
      <Container className={classes.desktopContainer}>
        <Paper elevation={1}>
          <PracticeStatesTable
            rows={filteredRows}
            loading={dataLoading}
          />
        </Paper>
      </Container>
    </ProviderLayout>
  );
};
